module.exports = __webpack_public_path__ + "img/681-7d6d9e.png";